module.exports = __webpack_public_path__ + "static/img/wuLianWang_details.c599514b.jpg";